import { render, staticRenderFns } from "./CustomerSignUpReview.vue?vue&type=template&id=f1799ce6"
import script from "./CustomerSignUpReview.vue?vue&type=script&lang=js"
export * from "./CustomerSignUpReview.vue?vue&type=script&lang=js"
import style0 from "./CustomerSignUpReview.vue?vue&type=style&index=0&id=f1799ce6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports